import React from 'react';

import './content-showcase__gradient.scss';

interface Props {
    colors?: (string | null)[];
}

export const ContentShowcaseGradient = React.memo((props: Props) => {
    const { colors } = props;

    return (
        <div className="content-showcase-widget__gradient">
            {colors && colors[0] && (
                <svg
                    className="content-showcase-widget__gradient-first"
                    fill="none"
                    height="333"
                    viewBox="0 0 329 333"
                    width="329"
                >
                    <path
                        d="M1.71015 54.3205L0 59.4179L0 163.275L15.9327 287.436C20.5587 323.485 59.7963 343.789 91.8967 326.744L271.05 231.614C296.076 218.326 314.723 195.552 322.812 168.397L323.428 166.331C335.533 125.695 324.968 81.6874 295.734 50.9755C291.6 46.6318 286.983 42.7737 281.974 39.4761L222.009 0L45.0019 0.000312374C24.6324 12.4527 9.30382 31.6862 1.71015 54.3205Z"
                        fill={colors[0]}
                    />
                </svg>
            )}
            {colors && colors[1] && (
                <svg
                    className="content-showcase-widget__gradient-second"
                    fill="none"
                    height="195"
                    viewBox="0 0 411 195"
                    width="411"
                >
                    <path
                        d="M272.861 0.983493L172.695 11.2096C112.79 17.3254 59.9148 53 31.8166 106.259L3.56908 159.801C-4.86302 175.784 6.72541 195 24.7961 195L336.068 195C370.139 195 399.803 171.728 407.913 138.636C411.236 125.076 410.654 110.853 406.234 97.6104L401.772 84.2415C383.581 29.7405 330.021 -4.852 272.861 0.983493Z"
                        fill={colors[1]}
                    />
                </svg>
            )}
        </div>
    );
});
